var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSuccessBgGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 110,
    height: 110,
    rx: 55,
    fill: "#7BCB45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4655 35.0638C84.7198 36.3181 84.7198 38.3517 83.4655 39.606L48.1351 74.9365C46.8807 76.1908 44.8471 76.1908 43.5928 74.9365L27.5335 58.8772C26.2792 57.6229 26.2792 55.5892 27.5335 54.3349C28.7878 53.0806 30.8215 53.0806 32.0758 54.3349L45.8639 68.1231L78.9233 35.0638C80.1776 33.8095 82.2112 33.8095 83.4655 35.0638Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4376 34.5776C79.9604 33.0548 82.4293 33.0548 83.9521 34.5776C85.4749 36.1004 85.4749 38.5694 83.9521 40.0922L48.6217 75.4226C47.0989 76.9454 44.6299 76.9454 43.1072 75.4226L27.0479 59.3633C25.5251 57.8405 25.5251 55.3716 27.0479 53.8488C28.5707 52.326 31.0396 52.326 32.5624 53.8488L45.8644 67.1508L78.4376 34.5776ZM82.9799 35.5499C81.994 34.5641 80.3957 34.5641 79.4099 35.5499L46.3506 68.6092C46.0821 68.8777 45.6468 68.8777 45.3783 68.6092L31.5901 54.8211C30.6043 53.8352 29.006 53.8352 28.0201 54.8211C27.0343 55.8069 27.0343 57.4052 28.0201 58.391L44.0794 74.4503C45.0652 75.4362 46.6636 75.4362 47.6494 74.4503L82.9799 39.1199C83.9657 38.1341 83.9657 36.5357 82.9799 35.5499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccessBgGreen);
export default __webpack_public_path__ + "static/media/icSuccessBgGreen.d71191a325e2aafa781b7eb7dcf68d0e.svg";
export { ForwardRef as ReactComponent };